<div class="container" id="wrap">
    <div class="col-lg-12">
        <br />
    </div>
    <div class="col-lg-12">
        <div class="col-lg-3"></div>
        <div class="col-lg-6 text-center">
            <img class="logo-landing" src="assets/images/logos/ic.svg" style="width: 70%;" alt="" />
        </div>
        <div class="col-lg-3"></div>
    </div>
    <div class="col-lg-12">
        <br />
    </div>
    <div class="col-lg-3"></div>
    <div class="col-lg-6">
        <div class="bg-registro-light" style="padding-top: 10px;padding-bottom: 10px; overflow: hidden;">
            <form [formGroup]="RegisterForm" (ngSubmit)="finishRegister()" class="row form-horizontal" novalidate>
                <div class="form-horizontal">
                    <div class="row text-center">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">
                            <h3 class="f24" style="font-weight: 600;">Registro</h3>
                        </div>
                        <div class="col-lg-2"></div>

                    </div>
                    <div class="row text-center mobile-content-hide">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">
                            <p class="subtitulo_normal">Puedes registrarte con tu cuenta de Google o crear una cuenta
                                con tu
                                correo contraseña</p>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                    <div class="row">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">
                            <a type="button" class=" btn btn-lg btn-block btn-google" (click)="socialSignIn()">
                                <img src="assets/images/icons/icon-google.svg"
                                    style="height: 17px; vertical-align: middle;" alt="" /> &nbsp; &nbsp; Inicia sesión
                                con Google
                            </a>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>

                    <div class="row">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">
                            <div class="position-o-separacion mobile-content-hide"
                                style="position: absolute; top:2px; left:48%; background-color: #ffffff; padding: 3px;">
                                o</div>
                            <div class="position-o-separacion mobile-content-show"
                                style="position: absolute; top:-14px; left:48%; background-color: #ffffff; padding: 3px;">
                                o</div>
                            <hr>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>

                    <!-- <div class="col-sm-12">
                    <p style="font-size: 16px;">Cuéntanos, ¿dónde trabajas?</p>
                </div> -->
                    <div class="row form-group">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <label class="control-label label-usuario-registro">Nombre</label>
                            <input name="nombre_asociado" id="nombre_asociado" formControlName="nombre_asociado"
                                type="text" placeholder="Ingresa tu nombre"
                                class="form-control input-md placeholder-input input-form-usuario-registro"
                                required="required"
                                [ngClass]="{'is-valid': RegisterForm.get('nombre_asociado').valid ,'is-invalid':RegisterForm.get('nombre_asociado').invalid && (RegisterForm.get('nombre_asociado').dirty) }">
                            <div class=""
                                *ngIf="RegisterForm.get('nombre_asociado').invalid  && (RegisterForm.get('nombre_asociado').dirty) ">
                                <div [hidden]="!RegisterForm.get('nombre_asociado').errors['required']"
                                    class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-circle"></i> Debes ingresar el nombre.
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2"></div>
                    </div>

                    <div class="row form-group">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <label class="control-label label-usuario-registro">Apellido</label>
                            <input name="apellido_asociado" formControlName="apellido_asociado" type="text"
                                placeholder="Ingresa tu apellido"
                                class="form-control input-md placeholder-input input-form-usuario-registro"
                                required="required"
                                [ngClass]="{'is-valid': RegisterForm.get('apellido_asociado').valid, 'is-invalid':RegisterForm.get('apellido_asociado').invalid && (RegisterForm.get('apellido_asociado').dirty) }">
                            <div class=""
                                *ngIf="RegisterForm.get('apellido_asociado').invalid  && (RegisterForm.get('apellido_asociado').dirty)">
                                <div *ngIf="RegisterForm.get('apellido_asociado').errors['required']"
                                    class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-circle"></i> Debes ingresar el apellido.
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2"></div>

                    </div>

                    <div class="row form-group">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <label class="control-label label-usuario-registro">Correo electrónico</label>
                            <input name="email_asociado" formControlName="email_asociado" type="email"
                                class="form-control input-md placeholder-input input-form-usuario-registro"
                                required="required" placeholder="Ejemplo:nombre@miempresa.com"
                                [ngClass]="{'is-valid': RegisterForm.get('email_asociado').valid, 'is-invalid':RegisterForm.get('email_asociado').invalid && (RegisterForm.get('email_asociado').dirty) }">
                            <div class=""
                                *ngIf="RegisterForm.get('email_asociado').invalid  && (RegisterForm.get('email_asociado').dirty || RegisterForm.get('email_asociado').touched)">

                                <div *ngIf="RegisterForm.get('email_asociado').errors['required']"
                                    class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-circle"></i> Debes ingresar Correo electrónico.
                                </div>
                                <div *ngIf="RegisterForm.get('email_asociado').errors['email']"
                                    class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-circle"></i> Formato de Correo electrónico
                                    inválido.
                                </div>
                            </div>
                            <div *ngIf="emailExist"
                                class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                <i class="fa fa-exclamation-circle"></i> Este Correo electrónico ya se encuentra
                                registrado en el Marketplace.
                            </div>
                        </div>
                        <div class="col-sm-2"></div>
                    </div>

                    <div class="row form-group">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <label class="control-label label-usuario-registro">Confirmar correo</label>
                            <input name="confirmemail_asociado" formControlName="confirmemail_asociado" type="email"
                                placeholder="Vuelve a Ingresar tu correo"
                                class="form-control input-md placeholder-input input-form-usuario-registro"
                                required="required"
                                [ngClass]="{'is-valid': RegisterForm.get('confirmemail_asociado').valid, 'is-invalid':RegisterForm.get('confirmemail_asociado').invalid && (RegisterForm.get('confirmemail_asociado').dirty) }">
                            <div class=""
                                *ngIf="RegisterForm.get('confirmemail_asociado').invalid  && (RegisterForm.get('confirmemail_asociado').dirty || RegisterForm.get('confirmemail_asociado').touched)">
                                <div *ngIf="RegisterForm.get('confirmemail_asociado').errors['required']"
                                    class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-circle"></i> Debes ingresar el correo
                                    electrónico.
                                </div>
                                <div *ngIf="RegisterForm.get('confirmemail_asociado').errors['email']"
                                    class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-circle"></i> Formato de correo electrónico
                                    inválido.
                                </div>
                                <div *ngIf="RegisterForm.get('confirmemail_asociado').errors['mustMatch']"
                                    class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-circle"></i> Los correos no coinciden.
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2"></div>

                    </div>

                    <div class="row form-group">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <label class="control-label label-usuario-registro">
                                Contraseña <small style="font-size: 12px;">(mínimo 6 caracteres)</small>
                            </label>
                            <input name="password" formControlName="password" type="password"
                                placeholder="Ingresa tu contraseña"
                                class="form-control input-md placeholder-input input-form-usuario-registro"
                                minlength="6" required="required"
                                [ngClass]="{'is-valid': RegisterForm.get('password').valid, 'is-invalid':RegisterForm.get('password').invalid && (RegisterForm.get('password').dirty) }">
                            <div class=""
                                *ngIf="RegisterForm.get('password').invalid  && (RegisterForm.get('password').dirty)">
                                <div *ngIf="!RegisterForm.get('password').errors['required']"
                                    class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-tricircleangle"></i> Debes ingresar tu
                                    contraseña.
                                </div>
                                <div *ngIf="!RegisterForm.get('password').errors['minlength']"
                                    class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-circle"></i> La contraseña debe tener minimo 6
                                    caracteres.
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2"></div>
                    </div>

                    <div class="row form-group">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <label class="control-label"
                                style="font-size: 14px; font-weight: 600; color:#323130;">Confirmar
                                contraseña</label>
                            <input name="confirmpassword" formControlName="confirmpassword" type="password"
                                placeholder="Vuelve a ingresar tu contraseña"
                                class="form-control input-md placeholder-input input-form-usuario-registro"
                                minlength="6" required="required"
                                [ngClass]="{'is-valid': RegisterForm.get('confirmpassword').valid, 'is-invalid':RegisterForm.get('confirmpassword').invalid && (RegisterForm.get('confirmpassword').dirty) }">
                            <div class=""
                                *ngIf="RegisterForm.get('confirmpassword').invalid  && RegisterForm.get('confirmpassword').dirty">
                                <div [hidden]="!RegisterForm.get('confirmpassword').errors['required']"
                                    class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-circle"></i> Debes ingresar tu contraseña.
                                </div>
                                <div [hidden]="!RegisterForm.get('confirmpassword').errors['minlength']"
                                    class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-circle"></i> La contraseña debe tener minimo 6
                                    caracteres.
                                </div>
                                <div [hidden]="!RegisterForm.get('confirmpassword').errors['mustMatch']"
                                    class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-circle"></i> Las contraseñas no coinciden.
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2"></div>
                    </div>

                    <div class="row">
                        <div class="col-lg-12 form-group">
                            <re-captcha #captchaRef="reCaptcha" name="captcha" formControlName="captcha"></re-captcha>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8"><button type="submit" class="btn btn-lg btn-orange btn-block"
                                [disabled]="!RegisterForm.valid">Crear Cuenta</button><br></div>
                        <div class="col-lg-2"></div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>